exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditFormSectionComponent>.v-card{position:relative;padding:1rem 1rem 2.5rem;background:rgba(0,108,223,.22)}", ""]);

// exports
